import * as React from 'react';
/**
 *
 * Original name: Android share
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=14152%3A10
 *
 */
export const AndroidShareLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M16.5 9c-.837 0-1.46-.202-1.875-.613l-5.652 3.109A4.4 4.4 0 0 1 9 12a4.4 4.4 0 0 1-.027.504l5.652 3.109c.415-.41 1.038-.613 1.875-.613 1.682 0 2.5.818 2.5 2.5s-.818 2.5-2.5 2.5-2.5-.818-2.5-2.5c0-.178.01-.346.027-.504l-5.652-3.109c-.415.41-1.038.613-1.875.613-1.682 0-2.5-.818-2.5-2.5s.818-2.5 2.5-2.5c.837 0 1.46.202 1.875.613l5.652-3.109A4.396 4.396 0 0 1 14 6.5c0-1.682.818-2.5 2.5-2.5s2.5.818 2.5 2.5S18.182 9 16.5 9Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
